import Timer from './Timer';

export default Timer; 